var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeriod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1667 0.666992C13.627 0.666992 14.0001 1.04009 14.0001 1.50033V2.33366H14.8334C16.2141 2.33366 17.3334 3.45295 17.3334 4.83366V14.8337C17.3334 16.2144 16.2141 17.3337 14.8334 17.3337H3.16675C1.78604 17.3337 0.666748 16.2144 0.666748 14.8337V4.83366C0.666748 3.45295 1.78604 2.33366 3.16675 2.33366H4.00008V1.50033C4.00008 1.04009 4.37318 0.666992 4.83342 0.666992C5.29365 0.666992 5.66675 1.04009 5.66675 1.50033V2.33366H12.3334V1.50033C12.3334 1.04009 12.7065 0.666992 13.1667 0.666992ZM15.6667 9.00033H2.33341V14.8337C2.33341 15.2939 2.70651 15.667 3.16675 15.667H14.8334C15.2937 15.667 15.6667 15.2939 15.6667 14.8337V9.00033ZM13.1667 10.667C13.627 10.667 14.0001 11.0401 14.0001 11.5003V13.167C14.0001 13.6272 13.627 14.0003 13.1667 14.0003H11.5001C11.0398 14.0003 10.6667 13.6272 10.6667 13.167V11.5003C10.6667 11.0401 11.0398 10.667 11.5001 10.667H13.1667ZM4.00008 4.00033H3.16675C2.70651 4.00033 2.33341 4.37342 2.33341 4.83366V7.33366H15.6667V4.83366C15.6667 4.37342 15.2937 4.00033 14.8334 4.00033H14.0001V4.83366C14.0001 5.2939 13.627 5.66699 13.1667 5.66699C12.7065 5.66699 12.3334 5.2939 12.3334 4.83366V4.00033H5.66675V4.83366C5.66675 5.2939 5.29365 5.66699 4.83341 5.66699C4.37318 5.66699 4.00008 5.2939 4.00008 4.83366V4.00033Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeriod);
export default __webpack_public_path__ + "static/media/period.aa8f7a9b.svg";
export { ForwardRef as ReactComponent };